<template>
  <div class="forumIntroduceByPeriod" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule"/>
    <div class="content">
      <div class="day" v-for="item in periodsInfo">
        <img :src="image" v-for="image in item"
             :style="{transform:`translate3d(${firstImagePosition}px,0,0)`}">
      </div>
    </div>
  </div>
</template>

<script>
  import ModuleNav from './ModuleNav';
  import { mapState } from 'vuex';

  export default {
    name: 'ForumIntroduceByPeriod',
    components: { ModuleNav },
    computed: {
      ...mapState({
        nav: state => state.forumIntroduceByPeriod.nav,
        periodsInfo: state => state.forumIntroduceByPeriod.periodsInfo,
      }),
    },
    data() {
      return {
        isInModule: false,
        scrollHeight: 0,
        firstImagePosition: 0,
        secondImagePosition: 0,
        thirdImagePosition: 0,
      };
    },
    created() {
      window.addEventListener('scroll', this.handleScroll, false);
    },
    methods: {
      mouseEnter() {
        this.isInModule = true;
      },
      mouseLeave() {
        this.isInModule = false;
      },
      handleScroll() {
        const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const scrollInstance = scrollHeight - this.scrollHeight;
        this.scrollHeight = scrollHeight;
        const { left, width } = document.querySelector('.forumIntroduceByPeriod')
          .getBoundingClientRect();
        if (left <= document.body.offsetWidth && left >= -width) {
          this.firstImagePosition -= scrollInstance / 30;
          this.secondImagePosition -= scrollInstance / 40;
          this.thirdImagePosition -= scrollInstance / 50;
        }
      },
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  };
</script>

<style scoped lang="less">
  .forumIntroduceByPeriod {
    display: flex;
    height: 100vh;
  }

  .content {
    display: flex;
    height: 86vh;
    margin-top: 7vh;
  }

  .day {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    width: 62vh;
    height: 100%;
    padding: 0 5vh;
    position: relative;

    &:not(:first-of-type) {
      margin-left: 1px;
    }

    &:not(:last-of-type) {
      border-right: 1px solid #000;
    }

    img {
      width: 90%;
      align-self: flex-end;
      transition: transform .5s ease-out;
    }
  }


</style>
